export default __webpack_public_path__ + "static/img30v-e887252812c994ba9b83f49cd823cc60.jpg";